<pbc-sorter [config]="DateiArtsSorterConfig" [sorter]="dateiArts.sorter$ | async" (sorterChange)="dateiArts.sorter$.next($event)"></pbc-sorter>
